import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { class: "p-col-4 p-sm-4 p-md-3  p-p-0" }
const _hoisted_3 = { class: "kn-list-item" }
const _hoisted_4 = { class: "kn-list-item-text" }
const _hoisted_5 = {
  key: 0,
  class: "pi pi-exclamation-triangle kn-warning-icon"
}
const _hoisted_6 = { class: "p-col-8 p-sm-8 p-md-9  p-p-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Listbox = _resolveComponent("Listbox")
  const _component_SchedulerTimingOutputDocumentDetail = _resolveComponent("SchedulerTimingOutputDocumentDetail")
  const _component_Message = _resolveComponent("Message")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Listbox, {
        class: "kn-list--column",
        options: _ctx.documents,
        onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDocumentDetail($event.value)))
      }, {
        empty: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
        ]),
        option: _withCtx((slotProps) => [
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", null, _toDisplayString(slotProps.option.label), 1)
            ]),
            (_ctx.documentInvalid(slotProps.option))
              ? (_openBlock(), _createBlock("i", _hoisted_5))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["options"])
    ]),
    _createVNode("div", _hoisted_6, [
      (_ctx.selectedDocument)
        ? (_openBlock(), _createBlock(_component_SchedulerTimingOutputDocumentDetail, {
            key: 0,
            propDocument: _ctx.selectedDocument,
            functionalities: _ctx.functionalities,
            datasets: _ctx.datasets,
            jobInfo: _ctx.jobInfo,
            documentWithUniqueMail: _ctx.documentWithUniqueMail,
            onSendUniqueMailSelected: _ctx.onSendUniqueMailSelected,
            onUniqueMailOptionsChanged: _ctx.updateOtherDocumentsAfterUniqueMailSelected
          }, null, 8, ["propDocument", "functionalities", "datasets", "jobInfo", "documentWithUniqueMail", "onSendUniqueMailSelected", "onUniqueMailOptionsChanged"]))
        : (_openBlock(), _createBlock(_component_Message, {
            key: 1,
            class: "p-m-4",
            severity: "info",
            closable: false,
            style: _ctx.schedulerTimingOutputOutputTabDescriptor.styles.message
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('managers.scheduler.noDocumentSelected')), 1)
            ]),
            _: 1
          }, 8, ["style"]))
    ])
  ]))
}